import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  FormText,
} from 'reactstrap';
import {
  BtnOutlineRed,
  BtnOutlineGreen,
  BtnModalTable,
} from '../../styled-components';
import DateInput from '../../commons/DateInput';
import { useLoading } from '../../commons/Loading';
import axios from 'axios';
import { useAuth } from '../../commons/Auth';
import PanoramicaInsuranceTabel from './PanoramicaInsuranceTabel';

function ModalNoInsurance(props) {
  const {
    data = {},
    onConfirm = () => {},
    year,
    fetchTotalInsurances = () => {},
  } = props;
  const [t] = useTranslation('CONTACTS');
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();
  const [{ newToken, profile = {} } = {}] = useAuth();

  const [modal, setModal] = useState(false);
  const [modalReport, setModalReport] = useState(false);
  const [insurances, setInsurances] = useState([]);
  const [accountability, setAccountability] = useState(undefined);
  const [formError, setFormError] = useState(false);

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  const toggle = () => {
    setModal(!modal);
    setAccountability(undefined);
    setFormError(false);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!accountability) return setFormError(true);
    if (accountability.getFullYear() > currentYear) {
      toggle();
      return alert.error(t('INSURANCES:NO_INSURANCE_DATE_ERR'));
    }
    if (
      accountability.getFullYear() === currentYear &&
      accountability.getMonth() > currentMonth
    ) {
      toggle();
      return alert.error(t('INSURANCES:NO_INSURANCE_DATE_ERR'));
    }
    onConfirm({
      supplier: data.profileId,
      month: accountability.getMonth() + 1,
      year: accountability.getFullYear(),
    });
    toggle();
  };

  const toggleReport = () => {
    setModalReport(!modalReport);
  };
  const listenForEscapeEvent = () => {
    document.addEventListener('keydown', ({ key }) => {
      if (key === 'Escape') toggle();
    });
  };

  const [totExtraGross, setTotExtraGross] = useState(0);
  let totalExtraGross = 0;
  const fetchInsurances = async () => {
    showLoading();
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/insurances-by-month-panoramica/year/${data.profileId}`,
      {
        headers: { Authorization: newToken },
        params: { year },
      }
    );

    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    for (const insurance of response.data) {
      totalExtraGross = totalExtraGross + insurance?.shareToInvoice;
    }
    setTotExtraGross(totalExtraGross.toFixed(2));
    setInsurances(
      response.data.map((item) => {
        return { ...item, extraGross: item?.shareToInvoice };
      })
    );
    hideLoading();
  };

  const confirmPreview = async () => {
    showLoading();
    const selectedInsurances = insurances.map((elem) => String(elem._id));
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/panoramica-invoices/${data.profileId}/invoices-by-admin`,
      {
        selectedInsurances,
      },
      {
        headers: { Authorization: newToken },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    alert.success(t('COMMON:SUCCESS_UPDATE'));

    setInsurances([]);
    toggleReport();
    fetchTotalInsurances();
  };

  return (
    <React.Fragment>
      <div className="flex-check">
        <BtnModalTable
          type="button"
          onClick={toggle}
          style={{ marginRight: '10px' }}
        >
          {t('INVOICES:NO_INVOICE_BUTTON')}
        </BtnModalTable>

        {!profile._id && (
          <BtnModalTable
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              toggleReport();
              fetchInsurances();
            }}
          >
            {t('INSURANCES:REPORT_EVERYTHING')}
          </BtnModalTable>
        )}
      </div>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {t('INSURANCES:NO_INSURANCE_THIS_MONTH')}
        </ModalHeader>
        <Form onSubmit={onSubmit}>
          <ModalBody>
            <div className="max-width-form">
              <FormGroup>
                <DateInput
                  className="text-center"
                  name="accountability"
                  value={accountability && accountability.toISOString()}
                  showOnlyMonth
                  setMidday
                  returnDateObject
                  onChange={(accountability) => {
                    setAccountability(accountability);
                  }}
                />
                {formError && (
                  <FormText className="error-message">
                    {t('COMMON:REQUIRED')}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <p>{t('COMMON:CONFIRM_WARNING')}</p>
            <p>{t('INSURANCES:NO_INSURANCE_THIS_MONTH_WARNING')}</p>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal
        isOpen={modalReport}
        className="new-insurance-modal"
        onOpened={listenForEscapeEvent}
      >
        <ModalHeader toggle={toggleReport}>
          Anteprima Assicurazioni da Rendicontare
          <br />
        </ModalHeader>
        <ModalBody>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5 style={{ fontFamily: "'Open Sans', sans-serif" }}>
              Totale da rendicontare: € {totExtraGross}
            </h5>
            <h5 style={{ fontFamily: "'Open Sans', sans-serif" }}>
              Assicurazioni da Rendicontare: {insurances.length}
            </h5>
          </div>
          {insurances.length > 0 ? (
            <PanoramicaInsuranceTabel
              data={insurances}
              onFilter={() => {}}
              query={{
                limit: insurances.length,
                offset: 0,
              }}
              total={insurances.length}
            />
          ) : (
            <div style={{ textAlign: 'center' }}>
              {' '}
              Non ci sono assicurazioni da rendicontare{' '}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <BtnOutlineRed
            type="button"
            className="uppercase"
            onClick={toggleReport}
          >
            {t('COMMON:CANCEL')}
          </BtnOutlineRed>
          {insurances.length > 0 && (
            <BtnOutlineGreen
              type="button"
              className="uppercase"
              onClick={confirmPreview}
            >
              Conferma Rendicontazione
            </BtnOutlineGreen>
          )}
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}

export default ModalNoInsurance;
